import { Document, Page } from "react-pdf";

import ButtonLoader from "@/Components/Loaders/ButtonLoader";

export const LibraryViewCard = ({
  doc,
  handleDocPreview,
  modifiedView,
  cardWidth = 255,
  rowIndex,
  cardPositionInRow,
}) => {
  const getCardBackground = () => {
    const isEvenRow = rowIndex % 2 === 0;
    const isEvenPosition = cardPositionInRow % 2 === 0;
    if (isEvenRow) return isEvenPosition ? "var(--primary-4)" : "var(--primary-2)";
    return isEvenPosition ? "var(--primary-2)" : "var(--primary-4)";
  };

  const cardWidthPx = `${cardWidth}px`;
  const uploadDate = doc?.created_at ? new Date(doc.created_at).toLocaleDateString() : "—";

  return (
    <div className="d-flex flex-column align-items-center justify-content-center">
      <div
        className={`font-weight-semibold cursor-pointer detailed-empty-card ${modifiedView ? " " : ""}`}
        id="no-vertical-border"
        onClick={() => handleDocPreview(doc)}
        style={{
          width: cardWidthPx,
          minWidth: cardWidthPx,
          maxWidth: cardWidthPx,
          height: "327px",
          minHeight: "327px",
          border: "none",
          background: getCardBackground(),
        }}
      >
        <div
          id={`${doc.id}-${doc.document_name}`}
          className="detailed-empty-card-img-div"
          style={{ height: "317px" }}
        >
          {doc?.upload_url ? (
            <Document file={doc.upload_url} error={<BrokenPreviewImage />}>
              <Page
                height={317}
                width={cardWidth - 10}
                pageNumber={1}
                renderTextLayer={false}
                renderAnnotationLayer={false}
              />
            </Document>
          ) : (
            <BrokenPreviewImage />
          )}
        </div>

        <div className="detailed-empty-card-details">
          <div className="detailed-empty-card-sub-head">
            <p className="detailed-empty-card-sub-head-label">Client: </p>
            <p title={doc?.source_client_name}>{doc?.source_client_name || "—"}</p>
          </div>
          <div className="detailed-empty-card-sub-head">
            <p className="detailed-empty-card-sub-head-label">Case: </p>
            <p title={doc?.source_case_name}>{doc?.source_case_name || "—"}</p>
          </div>
          <div className="detailed-empty-card-sub-head">
            <p className="detailed-empty-card-sub-head-label">Case Type: </p>
            <p>{doc?.source_case_type || "—"}</p>
          </div>
          <div className="detailed-empty-card-sub-head">
            <p className="detailed-empty-card-sub-head-label">Upload Date: </p>
            <p>{uploadDate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export const LibraryEmptyCard = ({
  slot,
  page,
  item,
  isDragging,
  refetchLoading,
  handleDrop,
  handleUploadPopup,
  isSlotUploading,
  style,
}) => {
  return (
    <div
      onDrop={(e) => handleDrop(e, slot.id, page?.page?.id, item?.id)}
      className={`dropzone-${slot.id}-${item?.id}-${page.page.id} font-weight-semibold cursor-pointer detailed-empty-card`}
      id="no-vertical-border"
      onClick={() => handleUploadPopup(slot?.id, item?.id, page?.page?.id)}
      style={{ ...style }}
    >
      {isSlotUploading(slot?.id, item?.id) && (isDragging || refetchLoading) ? (
        <div className="d-flex align-items-center justify-content-center">
          <ButtonLoader />
          <span style={{ marginLeft: "5px" }}>Uploading</span>
        </div>
      ) : (
        <div style={{ height: "95%" }} className="d-flex align-items-center justify-content-center">
          <div>
            <p style={{ textAlign: "center" }}>
              <svg viewBox="0 0 24 24" height={24} width={24} fill="none">
                <path
                  d="M4 12H20M12 4V20"
                  stroke="var(--primary-25)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </p>
            <p
              className="name"
              style={{
                fontWeight: 600,
                paddingBottom: "14px",
                color: "var(--primary-25)",
                textAlign: "center",
              }}
            >
              {slot?.slot_name ? `Add ${slot?.slot_name}` : "Add File"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

const BrokenPreviewImage = () => {
  return (
    <svg height={60} width={60} viewBox="0 0 64 64" fill="#000000">
      <polygon
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        points="23,1 55,1 55,63 9,63 9,15 "
      />
      <polyline
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        points="9,15 23,15 23,1 "
      />
      <circle
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        cx="32"
        cy="36"
        r="9"
      />
      <line
        fill="none"
        stroke="#000000"
        strokeWidth="2"
        strokeMiterlimit="10"
        x1="25.834"
        y1="29.834"
        x2="38.166"
        y2="42.166"
      />
    </svg>
  );
};
